<template>
  <div v-if="workerLinks.length > 0" class="tw-flex tw-gap-1" :data-test="`tc-links-${index}`">

    <a
      v-for="workerLink in workerLinks"
      :key="workerLink.url"
      :href="workerLink.url"
      :title="workerLink.title"
      target="_blank"
      @click.stop
    >
    <WdsIcon name="link" :size="16" />
    </a>

  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { WdsIcon } from '@worksome/wds-components'
import { FragmentType, graphql, useFragment } from '@/gql'

const TrustedContactLinksColumn = graphql(`
  fragment TrustedContactLinksColumn on TrustedContact {
    id
    worker {
      id
      profile {
        id
        links {
          title
          url
        }
      }
    }
  }
`)

const props = defineProps<{ row: FragmentType<typeof TrustedContactLinksColumn>; index: number }>()
const column = computed(() => useFragment(TrustedContactLinksColumn, props.row))
const workerLinks = computed(() => column.value.worker?.profile?.links ?? [])
</script>
